import { render, staticRenderFns } from "./MessageSend.vue?vue&type=template&id=1fe773d6"
import script from "./MessageSend.vue?vue&type=script&lang=js"
export * from "./MessageSend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fe773d6')) {
      api.createRecord('1fe773d6', component.options)
    } else {
      api.reload('1fe773d6', component.options)
    }
    module.hot.accept("./MessageSend.vue?vue&type=template&id=1fe773d6", function () {
      api.rerender('1fe773d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/feedback/MessageSend.vue"
export default component.exports